var map = {
	"./app/images/marker-new.png": 25979,
	"./cemeteries/images/marker-new.png": 1594,
	"./cosec/images/marker-new.png": 32403,
	"./cosi/images/marker-new.png": 86628,
	"./epl/images/marker-new.png": 83731,
	"./geoapi/images/marker-new.png": 55307,
	"./gim/images/marker-new.png": 62991,
	"./ig/images/marker-new.png": 57502,
	"./meubairro/images/marker-new.png": 33854,
	"./os/images/marker-new.png": 27404,
	"./ot/images/marker-new.png": 40195,
	"./pim/images/marker-new.png": 33016,
	"./potencialsolar/images/marker-new.png": 66988,
	"./psp/images/marker-new.png": 2351,
	"./pu/images/marker-new.png": 85875,
	"./toponymy/images/marker-new.png": 68923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27844;